// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.photobooks-tabs {
  display: flex;
  gap: 32px;
  align-items: center;
  padding: 40px 160px 0;
}

.photobooks-tab {
  background: none;
  border: none;
  padding: 0 0 12px;
  font-size: 18px;
  font-weight: 500;
  color: #8b8b8b;
  cursor: pointer;
  border-bottom: 2px solid transparent;
}

.photobooks-tab.active {
  color: #2e2e2e;
  border-bottom-color: #2e2e2e;
}

.photobooks-bestseller-section {
  padding: 32px 160px 80px;
}

.photobooks-breadcrumb {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 40px 160px;
}

.photobooks-breadcrumb a,
.photobooks-breadcrumb span {
  font-size: 16px;
  font-weight: 500;
  color: #a4a4a4;
  text-decoration: none;
}

.photobooks-breadcrumb-arrow {
  color: #a4a4a4;
}

.photobooks-breadcrumb-current {
  color: #000 !important;
}

.photobooks-content {
  display: flex;
  align-items: flex-start;
  gap: 32px;
  padding: 0 160px 56px;
}

/* Sidebar filters */
.photobooks-filters {
  flex: 0 0 256px;
  max-width: 256px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.photobooks-filters-header {
  border-bottom: 0.5px solid #b5b5b5;
  padding: 12px 0;
}

.photobooks-filters-header p {
  font-size: 18px;
  font-weight: 500;
  color: #2e2e2e;
  letter-spacing: 0.54px;
  margin: 0;
}

.photobooks-search input {
  width: 100%;
  box-sizing: border-box;
  background: #f5f5f5;
  border: none;
  border-radius: 8px;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #2e2e2e;
}

.photobooks-search input::placeholder {
  color: #656565;
  opacity: 0.5;
}

.photobooks-categories {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.photobooks-checkbox {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
}

.photobooks-checkbox input {
  display: none;
}

.photobooks-checkbox-box {
  width: 16px;
  height: 16px;
  border: 0.5px solid #d3d3d3;
  border-radius: 3px;
  flex-shrink: 0;
  position: relative;
}

.photobooks-checkbox input:checked + .photobooks-checkbox-box {
  background: #ca247b;
  border-color: #ca247b;
}

.photobooks-checkbox input:checked + .photobooks-checkbox-box::after {
  content: '';
  position: absolute;
  left: 4px;
  top: 1px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.photobooks-checkbox-label {
  font-size: 15px;
  font-weight: 500;
  color: #2e2e2e;
}

.photobooks-checkbox-count {
  font-size: 12px;
  font-weight: 400;
  color: #929292;
}

/* Main area */
.photobooks-main {
  flex: 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.photobooks-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
}

.photobooks-selected-count {
  font-size: 16px;
  color: #6c6c6c;
  margin: 0;
}

.photobooks-selected-count strong {
  font-size: 20px;
  color: #000;
}

.photobooks-sort {
  background: white;
  border: 0.5px solid #d4d4d4;
  border-radius: 8px;
  padding: 8px 16px;
  font-size: 15px;
  color: #000;
  max-width: 256px;
}

/* Pagination */
.photobooks-pagination {
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: center;
  padding-top: 16px;
}

.photobooks-pagination button {
  background: #f6f6f6;
  border: none;
  border-radius: 5px;
  padding: 4px 11px;
  font-size: 16px;
  font-weight: 500;
  color: #2e2e2e;
  cursor: pointer;
  min-width: 32px;
  height: 32px;
}

.photobooks-pagination button.active {
  background: #2e2e2e;
  color: white;
}

.photobooks-pagination button:disabled {
  opacity: 0.4;
  cursor: default;
}

@media (max-width: 1024px) {
  .photobooks-breadcrumb,
  .photobooks-tabs {
    padding: 24px 24px 0;
  }

  .photobooks-bestseller-section {
    padding: 24px 24px 56px;
  }

  .photobooks-content {
    padding: 0 24px 40px;
    flex-direction: column;
  }

  .photobooks-filters {
    flex: 1 1 auto;
    max-width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Photobooks.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oCAAoC;AACtC;;AAEA;EACE,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,qBAAqB;AACvB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,2BAA2B;EAC3B,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,SAAW;EACX,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;AACX;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE;;IAEE,oBAAoB;EACtB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,eAAe;EACjB;AACF","sourcesContent":[".photobooks-tabs {\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  padding: 40px 160px 0;\n}\n\n.photobooks-tab {\n  background: none;\n  border: none;\n  padding: 0 0 12px;\n  font-size: 18px;\n  font-weight: 500;\n  color: #8b8b8b;\n  cursor: pointer;\n  border-bottom: 2px solid transparent;\n}\n\n.photobooks-tab.active {\n  color: #2e2e2e;\n  border-bottom-color: #2e2e2e;\n}\n\n.photobooks-bestseller-section {\n  padding: 32px 160px 80px;\n}\n\n.photobooks-breadcrumb {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  padding: 40px 160px;\n}\n\n.photobooks-breadcrumb a,\n.photobooks-breadcrumb span {\n  font-size: 16px;\n  font-weight: 500;\n  color: #a4a4a4;\n  text-decoration: none;\n}\n\n.photobooks-breadcrumb-arrow {\n  color: #a4a4a4;\n}\n\n.photobooks-breadcrumb-current {\n  color: #000 !important;\n}\n\n.photobooks-content {\n  display: flex;\n  align-items: flex-start;\n  gap: 32px;\n  padding: 0 160px 56px;\n}\n\n/* Sidebar filters */\n.photobooks-filters {\n  flex: 0 0 256px;\n  max-width: 256px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.photobooks-filters-header {\n  border-bottom: 0.5px solid #b5b5b5;\n  padding: 12px 0;\n}\n\n.photobooks-filters-header p {\n  font-size: 18px;\n  font-weight: 500;\n  color: #2e2e2e;\n  letter-spacing: 0.54px;\n  margin: 0;\n}\n\n.photobooks-search input {\n  width: 100%;\n  box-sizing: border-box;\n  background: #f5f5f5;\n  border: none;\n  border-radius: 8px;\n  padding: 12px 16px;\n  font-size: 14px;\n  font-weight: 500;\n  color: #2e2e2e;\n}\n\n.photobooks-search input::placeholder {\n  color: #656565;\n  opacity: 0.5;\n}\n\n.photobooks-categories {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.photobooks-checkbox {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n}\n\n.photobooks-checkbox input {\n  display: none;\n}\n\n.photobooks-checkbox-box {\n  width: 16px;\n  height: 16px;\n  border: 0.5px solid #d3d3d3;\n  border-radius: 3px;\n  flex-shrink: 0;\n  position: relative;\n}\n\n.photobooks-checkbox input:checked + .photobooks-checkbox-box {\n  background: #ca247b;\n  border-color: #ca247b;\n}\n\n.photobooks-checkbox input:checked + .photobooks-checkbox-box::after {\n  content: '';\n  position: absolute;\n  left: 4px;\n  top: 1px;\n  width: 4px;\n  height: 8px;\n  border: solid white;\n  border-width: 0 2px 2px 0;\n  transform: rotate(45deg);\n}\n\n.photobooks-checkbox-label {\n  font-size: 15px;\n  font-weight: 500;\n  color: #2e2e2e;\n}\n\n.photobooks-checkbox-count {\n  font-size: 12px;\n  font-weight: 400;\n  color: #929292;\n}\n\n/* Main area */\n.photobooks-main {\n  flex: 1 0 0;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.photobooks-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 16px;\n}\n\n.photobooks-selected-count {\n  font-size: 16px;\n  color: #6c6c6c;\n  margin: 0;\n}\n\n.photobooks-selected-count strong {\n  font-size: 20px;\n  color: #000;\n}\n\n.photobooks-sort {\n  background: white;\n  border: 0.5px solid #d4d4d4;\n  border-radius: 8px;\n  padding: 8px 16px;\n  font-size: 15px;\n  color: #000;\n  max-width: 256px;\n}\n\n/* Pagination */\n.photobooks-pagination {\n  display: flex;\n  gap: 8px;\n  align-items: center;\n  justify-content: center;\n  padding-top: 16px;\n}\n\n.photobooks-pagination button {\n  background: #f6f6f6;\n  border: none;\n  border-radius: 5px;\n  padding: 4px 11px;\n  font-size: 16px;\n  font-weight: 500;\n  color: #2e2e2e;\n  cursor: pointer;\n  min-width: 32px;\n  height: 32px;\n}\n\n.photobooks-pagination button.active {\n  background: #2e2e2e;\n  color: white;\n}\n\n.photobooks-pagination button:disabled {\n  opacity: 0.4;\n  cursor: default;\n}\n\n@media (max-width: 1024px) {\n  .photobooks-breadcrumb,\n  .photobooks-tabs {\n    padding: 24px 24px 0;\n  }\n\n  .photobooks-bestseller-section {\n    padding: 24px 24px 56px;\n  }\n\n  .photobooks-content {\n    padding: 0 24px 40px;\n    flex-direction: column;\n  }\n\n  .photobooks-filters {\n    flex: 1 1 auto;\n    max-width: 100%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
